import { render, staticRenderFns } from "./UiPopup.vue?vue&type=template&id=34c84138"
import script from "./UiPopup.vue?vue&type=script&lang=js"
export * from "./UiPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports